
	import { Observer } from 'mobx-vue';
	import { Component, Vue } from 'vue-property-decorator';

	@Observer
	@Component
	export default class Snackbar extends Vue {}
